import React, { useState } from "react";
import { Form, Input, Button, Select, Row, Col, Modal, Typography, message } from "antd";
import { ExclamationCircleOutlined, DeleteOutlined, PlusCircleOutlined, LeftOutlined, RightOutlined} from "@ant-design/icons";
import { useHistory } from "react-router-dom";
import LeftLayout from "../pageHeader/LeftLayout";
import { mortageType } from "../../constants/DataConstants";
import { routes } from "../../routes/Routes";

const { Option } = Select;
const { confirm } = Modal;
const { Title, Text } = Typography;


const RealEstateAssets = () => {
    const [form] = Form.useForm();
    const [assets, setAssets] = useState([
        { name: "", outstandingMortgage: "", interestRate: "", mortgageType:""  },
    ]);
    const history = useHistory();

    const addAsset = () => {
        setAssets([
            ...assets,
            { name: "", outstandingMortgage: "", interestRate: "", mortgageType:""  },
        ]);
    };

    const deleteAsset = (index) => {
        confirm({
            title: "Are you sure you want to delete this real estate asset?",
            icon: <ExclamationCircleOutlined />,
            okText: "Yes",
            cancelText: "No",
            onOk() {
                setAssets(assets.filter((_, idx) => idx !== index));
            },
        });
    };

    const onBack = () => {
        history.push(routes.liquidity.path);
    };

    const onNext = () => {
        history.push(routes.businessAssets.path);
    };

    const onFinish = (values) => {
        message.success("Real Estate Assets Saved!");
        onNext();
    };

    return (
        <LeftLayout>
            <Row className="rightbox" >
                <Col span={24}>
                    <Title level={3} style={{ marginTop: 40 }}>
                        Real Estate Assets 
                    </Title>
                    <Form
                        form={form}
                        layout="vertical"
                        onFinish={onFinish}
                    >
                        {assets.map((asset, idx) => (
                            <div key={idx}>
                                <Row justify="space-between" align="middle" style={{ marginTop: 30 }}>
                                    <Col>
                                        <Text strong style={{ fontSize: 16 }}>
                                            Property {String(idx + 1).padStart(2, "0")}
                                        </Text>
                                    </Col>
                                    <Col>
                                        {idx > 0 && (
                                            <Button
                                                type="text"
                                                icon={<DeleteOutlined style={{ fontSize: 18 }} />}
                                                onClick={() => deleteAsset(idx)}
                                            />
                                        )}
                                    </Col>
                                </Row>

                                <Form.Item
                                    label="Property Value"
                                    name={["assets", idx, "name"]}
                                    rules={[{ required: true, message: "Property Value is required" }]}
                                    style={{ marginTop: 16 }}
                                    className='w50'
                                >
                                    <Input placeholder="$" />
                                </Form.Item>

                                <Form.Item
                                    label="Outstanding Mortgage"
                                    name={["assets", idx, "outstandingMortgage"]}
                                    rules={[{ required: true, message: "Outstanding Mortgage is required" }]}
                                    className='w50'
                                >
                                    <Input placeholder="$" />
                                </Form.Item>

                                <Form.Item
                                    label="Interest Rate"
                                    name={["assets", idx, "interestRate"]}
                                    rules={[{ required: true, message: "Interest Rate is required" }]}
                                    className='w50'
                                >
                                    <Input placeholder="%" />
                                </Form.Item>

                                <Form.Item
                                    label="Mortgage Type"
                                    name={["assets", idx, "mortgageType"]}
                                    rules={[{ required: true, message: "Mortgage Type is required" }]}
                                    className='w50'
                                >
                                    <Select placeholder="Select">
                                        {mortageType.map((type) => (
                                            <Option key={type.value} value={type.value}>
                                                {type.label}
                                            </Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                            </div>
                        ))}

                        <Form.Item >
                            <Button
                                type="link"
                                icon={<PlusCircleOutlined />}
                                onClick={addAsset}
                                style={{
                                    padding: 0,
                                    fontWeight: "bold",
                                    fontSize: 15,
                                    marginTop: 10,
                                }}
                            >
                                Add Another Real Estate Asset
                            </Button>
                        </Form.Item>

                        <Form.Item>
                            <div style={{ display: "flex", justifyContent: "flex-end", gap: 16 }} className="w95">
                                <Button
                                    onClick={onBack}
                                    icon={<LeftOutlined />}
                                >
                                    Go Back
                                </Button>
                                <Button
                                    type="primary"
                                    htmlType="submit"
                                >
                                    Save And Proceed <RightOutlined />
                                </Button>
                                <Button
                                    type="default"
                                    onClick={onNext}
                                >
                                    Next <RightOutlined />
                                </Button>
                            </div>
                        </Form.Item>
                    </Form>
                </Col>
            </Row>
        </LeftLayout>
    );
};

export default RealEstateAssets;

